var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 51,
    viewBox: "0 0 50 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_758_538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8571 50.5587H4.76205C2.14275 50.5587 0 48.4159 0 45.7967V8.8922C0 6.27289 2.14286 4.13014 4.76205 4.13014H42.8571C45.476 4.13014 47.6192 6.273 47.6192 8.8922V45.7967C47.6192 48.416 45.476 50.5587 42.8571 50.5587ZM4.76205 6.51095C3.45246 6.51095 2.3808 7.5826 2.3808 8.8922V45.7967C2.3808 47.1063 3.45246 48.1779 4.76205 48.1779H42.8571C44.1667 48.1779 45.238 47.1063 45.238 45.7967V8.8922C45.238 7.5826 44.1667 6.51095 42.8571 6.51095H4.76205Z",
    fill: "#4C4C4C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7141 0.558714H38.0949V10.0824H35.7141V0.558714ZM9.52347 0.558714H11.9047V10.0824H9.52347V0.558714ZM1.19043 16.0351H46.4284V18.4159H1.19043V16.0351Z",
    fill: "#4C4C4C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_758_538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "white",
    transform: "translate(0 0.558716)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.b47d70a3b11fb8cb5e08281d33f299e5.svg";
export { ForwardRef as ReactComponent };